import { pages, app } from '@vue3/configs'
import { pages as page2 } from '@/config'

export default {
  name: 'NavigationBar',
  data () {
    return {
      activeTab: 'home',
      tabs: [
        { label: this.$t('navBar.home'), url: pages.homePage, name: app.routerName.homePage },
        { label: this.$t('navBar.catalog'), url: pages.catalog, name: app.routerName.catalog },
        { label: this.$t('navBar.orders'), url: pages.orderList, name: app.routerName.orderList },
        { label: this.$t('navBar.sales'), url: pages.rewards, name: app.routerName.rewards }
      ]
    }
  },
  created () {
    this.activeTab = this.getSelectedTab()
  },
  watch: {
    $route () {
      this.activeTab = this.getSelectedTab()
    }
  },
  computed: {
    path () {
      return this.$route.path
    }
  },
  methods: {
    selectThisTab (item) {
      let route = item.url
      if (this.path === route) {
        return
      }
      this.$router.push(route)
    },
    handleSettingsClick () {
      this.$router.push('/profile')
    },
    getSelectedTab () {
      const routerName = this.$route.meta.headerTabGroup
      return (this.tabs.find(tab => tab.name === routerName)?.name) || ''
    }
  }
}
